// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"362":"6a8d60f5","465":"c8f71aba","510":"85338634","645":"daf1b082","831":"8d9348fc"}[chunkId] + ".chunk.js";
};